import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { FormControl } from "../form-control";
import Input from "../input";
import { Form, Formik, FormikContextType } from "formik";
import { ChangePasswordRequest } from "@app/types";
import { createRef } from "react";
import { changePasswordValidationSchema } from "@app/validations";

function ChangePasswordModal({ portalDialogRef }: PortalDialogProps) {
  const formRef = createRef<FormikContextType<ChangePasswordRequest>>();

  const onSubmit = (values: ChangePasswordRequest) => {
    if (!formRef.current) return;

    const bodyPasswordChange = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
    };

    portalDialogRef.close({ bodyPasswordChange });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Đổi mật khẩu</div>
        <Formik
          innerRef={formRef}
          initialValues={{
            newPassword: "",
            confirmPassword: "",
            oldPassword: "",
          }}
          onSubmit={onSubmit}
          validationSchema={changePasswordValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <div className="mt-7">
              <div className="text-sm mb-2">Mật khẩu cũ</div>
              <FormControl name="oldPassword">
                <Input
                  type="password"
                  className="mt-1 !w-[375px]"
                  placeholder="Nhập mật khẩu cũ"
                  inputClassName="!bg-[rgba(239,241,249,0.60)] !rounded-xl font-medium !h-[52px] !leading-[52px]"
                />
              </FormControl>
            </div>
            <div className="mt-7">
              <div className="text-sm mb-2">Mật khẩu mới</div>
              <FormControl name="newPassword">
                <Input
                  type="password"
                  className="mt-1 !w-[375px]"
                  placeholder="Nhập mật khẩu mới"
                  inputClassName="!bg-[rgba(239,241,249,0.60)] !rounded-xl font-medium !h-[52px] !leading-[52px]"
                />
              </FormControl>
            </div>
            <div className="mt-7">
              <div className="text-sm mb-2">Nhập lại mật khẩu</div>
              <FormControl name="confirmPassword">
                <Input
                  type="password"
                  className="mt-1 !w-[375px]"
                  placeholder="Nhập lại mật khẩu mới"
                  inputClassName="!bg-[rgba(239,241,249,0.60)] !rounded-xl font-medium !h-[52px] !leading-[52px]"
                />
              </FormControl>
            </div>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                type="submit"
                size="xs"
                label="Cập nhật"
                width="100%"
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default ChangePasswordModal;
